import { render, staticRenderFns } from "./RecoverType.vue?vue&type=template&id=666ab2e0&scoped=true"
import script from "./RecoverType.vue?vue&type=script&lang=js"
export * from "./RecoverType.vue?vue&type=script&lang=js"
import style0 from "./RecoverType.vue?vue&type=style&index=0&id=666ab2e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ab2e0",
  null
  
)

export default component.exports